import { render, staticRenderFns } from "./ConfeccionStyle.vue?vue&type=template&id=5cbc8c98&scoped=true&"
import script from "./ConfeccionStyle.vue?vue&type=script&lang=js&"
export * from "./ConfeccionStyle.vue?vue&type=script&lang=js&"
import style0 from "./ConfeccionStyle.vue?vue&type=style&index=0&id=5cbc8c98&prod&lang=scss&scoped=true&"
import style1 from "./ConfeccionStyle.vue?vue&type=style&index=1&id=5cbc8c98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc8c98",
  null
  
)

export default component.exports